import styled from 'styled-components';
import { font } from 'styles/globals';

export const Wrapper = styled.ul`
    display: flex;
    gap: 12px;
    text-wrap: nowrap;
    overflow-x: scroll;
    scrollbar-width: none;
    white-space: nowrap;
    
    > li:not(:last-child) {
        border-right: 2px solid #D1D1D6;
    }
`;

export const Item = styled.li`
    font-family: ${font.graphikCond};
    font-weight: 600;
    font-size: 16px
    line-height: 150%;
    letter-spacing: 0.5px;
    list-style: none;
    text-transform: uppercase;
    padding-right: 12px;
`;
